var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"}},[_c('iframe',{staticStyle:{"height":"100vh"},attrs:{"src":"https://app.efexpay.com/login?organizationID=proplat","width":"100%","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }